import React, {ReactNode} from 'react';
import {Image, ScrollView, StyleProp, View, ViewStyle} from 'react-native';
import {formsStyles} from '../Inputs/formStyles';
type Props = {
  children?: ReactNode | ReactNode[];
  type?: string;
  style?: StyleProp<ViewStyle>;
};

export function PageContainer({children, type, style = {}}: Props) {
  return (
    <View>
      {type && type === 'background' && (
        <View style={{backgroundColor: '#fff', marginBottom: '20%'}}>
          <Image
            style={[formsStyles.fondMobile, {top: -22}]}
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            source={require('../../../ressources/images/fondLogin.png')}
          />
          <ScrollView keyboardShouldPersistTaps="handled">
            <View style={formsStyles.webformContain}>
              <View
                style={[formsStyles.formContain, formsStyles.bgTrans, style]}>
                {children}
              </View>
            </View>
          </ScrollView>
        </View>
      )}
      {!type && (
        <ScrollView
          keyboardShouldPersistTaps="handled"
          style={{marginBottom: '20%'}}>
          <View style={[formsStyles.webformContain]}>
            <View style={[formsStyles.formContain, style]}>{children}</View>
          </View>
        </ScrollView>
      )}
    </View>
  );
}
